module.exports = __webpack_public_path__ + "img/img-tabs-2.4245c8f7.svg";